import { Link, routes } from 'wasp/client/router';

export function RecapEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 dark:bg-primary-950/30">
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
          className="text-primary-400 dark:text-primary-300"
        >
          <path
            d="M12 2L13.09 8.26L18 6L14.74 10.91L21 12L14.74 13.09L18 18L13.09 15.74L12 22L10.91 15.74L6 18L9.26 13.09L3 12L9.26 10.91L6 6L10.91 8.26L12 2Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <h3 className="mb-2 text-lg font-semibold text-neutral-700 dark:text-neutral-200">
        Your story starts here
      </h3>
      <p className="mb-6 max-w-xs text-sm text-neutral-500 dark:text-neutral-400">
        Read a few articles this week and your personal recap will come alive.
      </p>
      <Link
        to={routes.ArticlesRoute.to}
        className="rounded-lg bg-primary-600 px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
      >
        Discover this week&apos;s stories
      </Link>
    </div>
  );
}
